<span
  class="np-informer-trigger"
  [class.np-informer-trigger--open]="informerOpen"
  (click)="op.toggle($event)"
  pTooltip="Просроченные"
  tooltipPosition="top"
  tooltipStyleClass="p-n-tooltip"
  [showDelay]="200"
  [life]="1000">
  <i class="pi pi-stopwatch p-text-secondary"></i>
</span>

<p-overlayPanel
  #op
  [style]="{ width: 'min(400px, calc(100vw - 24px))' }"
  styleClass="dropdown-overlay-panel informer-overlay-panel-v2"
  (onShow)="onInformerShow()"
  (onHide)="onInformerHide()">
  <ng-template pTemplate="">
    <div class="inf-v2">
      <div class="inf-v2-head">
        <div class="inf-v2-head__left">
          <span
            class="inf-v2-head__accent"
            aria-hidden="true"></span>
          <crm-button
            type="button"
            icon="pi pi-refresh"
            styleClass="p-button-rounded text-white p-button-text mx-1"
            (onClick)="loadNotifications()"></crm-button>
          <p class="inf-v2-head__title">Просроченные</p>
        </div>
      </div>

      <div class="inf-v2-scroll">
        <div *ngIf="loading" class="inf-v2-loading-fill">
          <crm-spinner></crm-spinner>
        </div>
        <ng-container *ngIf="!loading">
          <div *ngFor="let expired of expiredTasksByType">
            <div
              *ngIf="expired.tasks?.length"
              class="inf-v2-section-label">
              {{ expired.title }}
            </div>
            <div
              *ngFor="let task of expired.tasks"
              class="flex px-3 py-2 gap-2 justify-content-between align-items-center inf-v2-card">
              <a
                [routerLink]="getEntityTypeLink(task)"
                (click)="op.hide()">
                {{ task.name }}
              </a>
              <crm-status-label
                [name]="task.status.name"
                [color]="task.status.color"></crm-status-label>
            </div>
          </div>
          <div
            *ngIf="paginationLoading"
            class="text-center py-3">
            <p-progressSpinner
              [style]="{
                width: '50px',
                height: '50px'
              }"></p-progressSpinner>
          </div>

          <div
            *ngIf="!countItems"
            class="inf-v2-empty">
            <crm-no-data [size]="NoDataSize"></crm-no-data>
            <h4 class="font-normal">Нет просроченных</h4>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
